<template>
  <div class="modal fade" id="confirm-ussage-charge" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" data-dismiss="modal" class="close close-btn" @click="$emit('close')">×</button></div>
        <div class="modal-body">
          <div v-if="confirmUssages" class="table-wrapper">
            <p>お支払い履歴</p>
            <table id="confirm-ussage-table" class="table table-bordered bg-white">
              <thead>
                <tr>
                  <th>請求日</th>
                  <th>内容</th>
                  <th colspan="2">金額(税込)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="confirmUssage in confirmUssages" :key="confirmUssage.id">
                  <td class="text-center">{{ confirmUssage.invoiceDate }}</td>
                  <td>
                    <div class="flexbox justify-between">
                      <span>{{ confirmUssage.content.planName }}（{{ confirmUssage.content.from }} ～ {{ confirmUssage.content.to }}）</span>
                      <span v-if="confirmUssage.content.payStatus === '1'" class="status font-bold">支払失敗</span>
                    </div>
                  </td>
                  <td class="text-right">{{ confirmUssage.content.amount }} 円</td>
                  <td class="text-center">
                    <button class="btn btn-warning" :disabled="confirmUssage.content.payStatus !== '0'" @click="handleClickReceipt(confirmUssage)">
                      領収書<i class="fa fa-arrow-circle-right fa-lg mr-l-5" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center">
            お支払いの明細はありません。
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" class="btn" @click="$emit('close')">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberPlanService from '@/services/memberplanservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      confirmUssages: null
    }
  },

  mounted () {
    this.getConfirmUssageInfo()
  },

  methods: {
    async getConfirmUssageInfo () {
      this.loader = this.$loading.show()
      await MemberPlanService.getConfirmUssageInfo()
        .then(response => {
          if (response.data && response.data.length) {
            this.confirmUssages = response.data
          }
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
      $('#confirm-ussage-charge').modal('show')
    },
    handleClickReceipt (confirmUssage) {
      let logParams = {
        name: eventCode.settings.plan_info_tab.click_receipt_button,
        properties: {
          invoiceDate: confirmUssage.invoiceDate
        }
      }
      EventService.postTrackLog(logParams)
      window.open(confirmUssage.hostedInvoiceUrl)
    }
  },

  beforeDestroy () {
    this.$emit('close')
  }
}
</script>
<style scoped>
  .modal-body {
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/view/setting/ConfirmUsageChargeModal.vue